function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".filter-1{fill:current;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "filter-1",
  d: "M15.4,2.42H6.46A1.84,1.84,0,0,0,3,2.42H1.57a.59.59,0,0,0,0,1.17H3a1.84,1.84,0,0,0,3.49,0H15.4a.59.59,0,1,0,0-1.17ZM4.71,3.68A.68.68,0,0,1,4,3,.67.67,0,0,1,5.38,3,.68.68,0,0,1,4.71,3.68Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "filter-1",
  d: "M15.4,7.45H14a1.84,1.84,0,0,0-3.49,0H1.57A.59.59,0,0,0,1,8a.58.58,0,0,0,.58.59h8.94a1.84,1.84,0,0,0,3.49,0h1.4A.59.59,0,0,0,16,8,.6.6,0,0,0,15.4,7.45ZM12.26,8.71A.67.67,0,1,1,12.93,8,.67.67,0,0,1,12.26,8.71Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "filter-1",
  d: "M15.4,12.49H9a1.85,1.85,0,0,0-3.5,0H1.57a.59.59,0,0,0,0,1.18H5.48a1.85,1.85,0,0,0,3.5,0H15.4a.59.59,0,0,0,0-1.18ZM7.23,13.75a.67.67,0,1,1,.67-.67A.67.67,0,0,1,7.23,13.75Z"
});

var SvgFilter = function SvgFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 18 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter.3d7b33e0.svg";
export { ForwardRef as ReactComponent };